module.exports = __webpack_public_path__ + "img/newInt-edit-icon.ec53fe37.svg";